// extracted by mini-css-extract-plugin
export default {"header":"Toolbar_header__U8q1W","title":"Toolbar_title__4Xc0W"};